const getAnalytics = ({ analytics }) => analytics;
const getImpressions = state => getAnalytics(state).impressions;
const getCollectedProductImpressions = state => getImpressions(state).product;
const getCollectedPromoImpressions = state => getImpressions(state).promotion;
const getCheckoutAnalytics = state => getAnalytics(state).checkout || {};
const getCurrentStep = state => getCheckoutAnalytics(state).step;
const getCheckoutOption = state => getCheckoutAnalytics(state).checkoutOption;
const getAdditionalStep = state => getCheckoutAnalytics(state).additionalStep;
const getLoginOption = state => getCheckoutAnalytics(state).loginOption;
const getPage = state => getAnalytics(state).page || {};
const getPageInfo = state => getAnalytics(state).pageInfo || {};
const getProductList = state => getAnalytics(state).productList || '';
const getCurrentPage = state => getPage(state).current || '';
const getCurrentProductList = state => getProductList(state).current || '';
const getAnalyticsCounter = state => getAnalytics(state).gtmCounter;
const getPrevLocation = state => getPage(state).location || '';
const getPdpAnalytics = state => getAnalytics(state).pdp || {};
const getAddReviewStartTime = state => getPdpAnalytics(state).startTime || '';
const getPageType = state => getPageInfo(state).pageType || '';

const getCurrentTypeGroup = (state, type) =>
    getAnalytics(state).gtmCounter.types.filter(e => e.type === type);
const getCurrentWrapper = (state, hash) => {
    const counter = getAnalytics(state).gtmCounter.types.filter(e => e.hash === hash);
    return counter[0] || {};
};

const getOrderConfirmationAnalytics = state => getAnalytics(state).orderConfirmation || {};
const getProceedPageLoad = state => getOrderConfirmationAnalytics(state).proceedPageLoad || '';
const getPageLoad = state => getAnalytics(state).isPageLoad || '';
const getCollectedStoryImpressions = state => getImpressions(state).story;

export default {
    getCollectedProductImpressions,
    getCollectedPromoImpressions,
    getCheckoutAnalytics,
    getCurrentStep,
    getCheckoutOption,
    getAdditionalStep,
    getLoginOption,
    getCurrentPage,
    getCurrentProductList,
    getCurrentTypeGroup,
    getCurrentWrapper,
    getPageInfo,
    getAnalyticsCounter,
    getPrevLocation,
    getProceedPageLoad,
    getPageLoad,
    getAddReviewStartTime,
    getPageType,
    getCollectedStoryImpressions,
};
